export default __webpack_public_path__ + "static/media/RMPMLogo_Stacked_FullColor.c4fb69c6.png";